import { forwardRef } from "react";

import type { ScrollView as ReactNativeScrollView } from "react-native";
import type { ScrollViewProps as BaseScrollViewProps } from "tamagui";
import { ScrollView as BaseScrollView } from "tamagui";

type ScrollViewProps = BaseScrollViewProps;
type ScrollViewRef = ReactNativeScrollView;

/* eslint-disable react/jsx-props-no-spreading -- ScrollView is a pass-through for other props */

const ScrollView = forwardRef<ScrollViewRef, ScrollViewProps>(
  // eslint-disable-next-line max-params -- forwardRef render functions require props and ref
  ({ children, ...rest }, forwardedRef) => {
    return (
      <BaseScrollView
        {...rest}
        ref={forwardedRef}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
      >
        {children}
      </BaseScrollView>
    );
  },
);
ScrollView.displayName = "ScrollView";
/* eslint-enable react/jsx-props-no-spreading */

export type { ScrollViewRef };
export default ScrollView;
